"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSmsQueue = exports.NotificationEmailQueue = exports.NotificationSummary = exports.Notification = exports.NotificationType = exports.NotificationQueueStatus = exports.NotificationSendingType = exports.NotificationStatus = void 0;
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["None"] = "NONE";
    NotificationStatus["Wait"] = "WAIT";
    NotificationStatus["Preparing"] = "PREPARING";
    NotificationStatus["Prepared"] = "PREPARED";
    NotificationStatus["Broken"] = "BROKEN";
    NotificationStatus["Done"] = "DONE";
    NotificationStatus["Failed"] = "FAILED";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
var NotificationSendingType;
(function (NotificationSendingType) {
    NotificationSendingType["Email"] = "EMAIL";
    NotificationSendingType["Sms"] = "SMS";
})(NotificationSendingType = exports.NotificationSendingType || (exports.NotificationSendingType = {}));
var NotificationQueueStatus;
(function (NotificationQueueStatus) {
    NotificationQueueStatus["Wait"] = "WAIT";
    NotificationQueueStatus["Sending"] = "SENDING";
    NotificationQueueStatus["Sent"] = "SENT";
    NotificationQueueStatus["Failed"] = "FAILED";
})(NotificationQueueStatus = exports.NotificationQueueStatus || (exports.NotificationQueueStatus = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["UserReg"] = "USER_REG";
    NotificationType["UserPasswordReset"] = "USER_PASSWORD_RESET";
    NotificationType["UserPasswordInit"] = "USER_PASSWORD_INIT";
    NotificationType["StudySubjectFirstReg"] = "STUDY_SUBJECT_FIRST_REG";
    NotificationType["StudySubjectFirstRegBulk"] = "STUDY_SUBJECT_FIRST_REG_BULK";
    NotificationType["StudySubjectFirstRegBySite"] = "STUDY_SUBJECT_FIRST_REG_BY_SITE";
    NotificationType["StudySubjectFirstRegBySiteBulk"] = "STUDY_SUBJECT_FIRST_REG_BY_SITE_BULK";
    NotificationType["StudySubjectReg"] = "STUDY_SUBJECT_REG";
    NotificationType["StudySubjectRegBulk"] = "STUDY_SUBJECT_REG_BULK";
    NotificationType["StudySubjectRandomNoAssign"] = "STUDY_SUBJECT_RANDOM_NO_ASSIGN";
    NotificationType["StudySubjectUnblindReq"] = "STUDY_SUBJECT_UNBLIND_REQ";
    NotificationType["StudySubjectUnblinded"] = "STUDY_SUBJECT_UNBLINDED";
    NotificationType["StudySdvAutoRelease"] = "STUDY_SDV_AUTO_RELEASE";
    NotificationType["StudyEsignAutoRelease"] = "STUDY_ESIGN_AUTO_RELEASE";
    NotificationType["StudyUserReg"] = "STUDY_USER_REG";
    NotificationType["StudyReportReg"] = "STUDY_REPORT_REG";
    NotificationType["StudyReportSub"] = "STUDY_REPORT_SUB";
    NotificationType["StudyIpDeliveryReq"] = "STUDY_IP_DELIVERY_REQ";
    NotificationType["StudyIpDeliveryAutoReq"] = "STUDY_IP_DELIVERY_AUTO_REQ";
    NotificationType["StudyIpDeliveryCancel"] = "STUDY_IP_DELIVERY_CANCEL";
    NotificationType["StudyIpDeliveryApprove"] = "STUDY_IP_DELIVERY_APPROVE";
    NotificationType["StudyIpDeliveryStart"] = "STUDY_IP_DELIVERY_START";
    NotificationType["StudyIpDeliveryConfirm"] = "STUDY_IP_DELIVERY_CONFIRM";
    NotificationType["StudyIpDispense"] = "STUDY_IP_DISPENSE";
    NotificationType["StudyIpReturn"] = "STUDY_IP_RETURN";
    NotificationType["StudyIpReturnReq"] = "STUDY_IP_RETURN_REQ";
    NotificationType["StudyIpReturnConfirm"] = "STUDY_IP_RETURN_CONFIRM";
    NotificationType["StudyIpReturnCancel"] = "STUDY_IP_RETURN_CANCEL";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
class Notification {
}
exports.Notification = Notification;
class NotificationSummary {
}
exports.NotificationSummary = NotificationSummary;
class NotificationEmailQueue {
}
exports.NotificationEmailQueue = NotificationEmailQueue;
class NotificationSmsQueue {
}
exports.NotificationSmsQueue = NotificationSmsQueue;
//# sourceMappingURL=notification.js.map